(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amazon-search-bar"] && !Shopify.designMode) return;
  try {
    const debounce = (fn, delay = 200) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  };

  document.querySelectorAll('[data-amazon-search]').forEach((form) => {
    const input = form.querySelector('input[name="q"]');
    const select = form.querySelector('[data-amazon-search-category]');
    const defaultSearchUrl = form.dataset.baseSearchUrl;
    const results = form.parentElement?.querySelector('[data-search-results]');
    const noResultsText = results?.dataset.noResults || '';
    let hasSearched = false;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!input || !defaultSearchUrl) return;

      const query = input.value.trim();
      if (!query) {
        input.focus();
        return;
      }

      const baseUrl = select ? select.value : defaultSearchUrl;
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('q', query);
      window.location.assign(url.toString());
    });

    if (results && input) {
      const renderResults = (items) => {
        if (!items || items.length === 0) {
          results.innerHTML = `<div class="amazon-search__results-empty">${noResultsText}</div>`;
        } else {
          results.innerHTML = items
            .map(
              (item, index) => `
                <a class="amazon-search__results-item" href="${item.url}">
                  ${
                    item.image && index < 3
                      ? `<span class="amazon-search__results-thumb" aria-hidden="true"><img loading="lazy" src="${item.image}" alt=""></span>`
                      : ''
                  }
                  <span class="amazon-search__results-content">
                    <span class="amazon-search__results-title">${item.title}</span>
                    ${
                      item.excerpt
                        ? `<span class="amazon-search__results-excerpt">${item.excerpt}</span>`
                        : ''
                    }
                  </span>
                </a>
              `
            )
            .join('');
        }
        results.classList.add('is-open');
      };

      const fetchSuggestions = debounce(async (query) => {
        if (query.length < 2) {
          results.classList.remove('is-open');
          results.innerHTML = '';
          return;
        }
        hasSearched = true;
        try {
          const searchUrl = new URL('/search/suggest.json', window.location.origin);
          searchUrl.searchParams.set('q', query);
          searchUrl.searchParams.set('resources[type]', 'product');
          searchUrl.searchParams.set('resources[limit]', '5');
          searchUrl.searchParams.delete('resources[fields]');
          searchUrl.searchParams.delete('resources[options][fields]');

          const response = await fetch(searchUrl.toString(), {
            headers: { 'Accept': 'application/json' },
          });
          if (!response.ok) throw new Error('Suggest request failed');
          const data = await response.json();
          const items = (data.resources?.results?.products || []).map((p) => {
            const excerpt = (p.body || '')
              .replace(/<[^>]+>/g, '')
              .trim()
              .slice(0, 120);
            return {
              title: p.title,
              url: p.url,
              price: null,
              image: p.featured_image?.url,
              excerpt: excerpt ? `${excerpt}${excerpt.length >= 120 ? '…' : ''}` : '',
            };
          });
          renderResults(items);
        } catch (error) {
          results.classList.remove('is-open');
          console.error('Predictive search error', error);
        }
      }, 200);

      input.addEventListener('input', (event) => {
        fetchSuggestions(event.target.value.trim());
      });

      input.addEventListener('focus', () => {
        if (results.innerHTML.trim() !== '' && hasSearched) {
          results.classList.add('is-open');
        }
      });

      document.addEventListener('click', (event) => {
        if (!results.contains(event.target) && !form.contains(event.target)) {
          results.classList.remove('is-open');
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
